import { fork, all } from 'redux-saga/effects';
import { watchApiTask } from 'app/sagas';
import { api } from 'app/api';
import * as actions from './reportGeneralPanelActions';

// Root module saga
export function* sagas() {
  yield all([]);
}
